import PropTypes from 'prop-types';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import {ToastType} from 'nav/toasts/ToastConstants';
import Toast from 'nav/toasts/Toast';
import ToastStore from 'nav/toasts/ToastStore';

class ToastsContainerConnector extends DataConnector {
  shouldSubscribeToRedux = false;
  stores = [ToastStore];

  enhanceProps() {
    return {toasts: this.toastStore().getToasts()};
  }
}

function ToastsContainer(props) {
  return (
    <div>
      {props.toasts.map((toast) => (
        <Toast
          id={toast.id}
          actions={toast.actions}
          actionText={toast.actionText}
          clipboardData={toast.clipboardData}
          isCloseable={toast.isCloseable}
          key={toast.id}
          message={toast.message}
          onActionClick={toast.onActionClick}
          onClose={toast.onClose}
          progress={toast.progress}
          skipCloseCallbackOnActions={toast.skipCloseCallbackOnActions}
          type={toast.type}
        />
      ))}
    </div>
  );
}
ToastsContainer.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      actions: PropTypes.arrayOf(
        PropTypes.shape({
          actionText: PropTypes.string,
          clipboardData: PropTypes.string,
          onActionClick: PropTypes.func,
        })
      ),
      actionText: PropTypes.string,
      clipboardData: PropTypes.string,
      isCloseable: PropTypes.bool.isRequired,
      message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
      onActionClick: PropTypes.func,
      onClose: PropTypes.func,
      progress: PropTypes.number,
      skipCloseCallbackOnActions: PropTypes.bool,
      type: PropTypes.oneOf([ToastType.INFO, ToastType.SUCCESS, ToastType.WARNING, ToastType.DANGER])
        .isRequired,
    }).isRequired
  ).isRequired,
};

export default ToastsContainerConnector.connect(ToastsContainer);
